import { Injectable, inject } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { RouteGuardService } from './service/route-guard.service';
import { View } from '../layout/model/interfaces/view.interface';

@Injectable({ providedIn: 'root' })
export class IframeViewGuard implements CanActivate {
  private routeGuardService = inject(RouteGuardService);


  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    // Get the full path including parent segments
    const fullPath = route.pathFromRoot
      .filter(r => r.url.length > 0)
      .map(r => r.url.map(segment => segment.path).join('/'))
      .join('/');

    // For legacy routes, we want to pass the full path to the iframe
    // The path will be something like 'project/tasks'
    const view: View = {
      route: fullPath,
      iframeUrl: fullPath, // The old app will handle this route
    };

    return this.routeGuardService.handleRoute(view, route);
  }
}